var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect2, _rect3, _g, _rect4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBmd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2402_3504",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2402_3504)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "#AF0100"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2402_3504",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2402_3504)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8179 11.5C15.8179 17.1415 16.2183 19.1008 18.6298 19.1008C21.0413 19.1008 21.7011 16.2587 21.4975 11.5H15.8179Z",
    fill: "#F7FCFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7594 14.7581C19.4342 14.7581 19.9812 13.9 19.9812 12.8415C19.9812 11.7829 19.4342 10.9248 18.7594 10.9248C18.0845 10.9248 17.5375 11.7829 17.5375 12.8415C17.5375 13.9 18.0845 14.7581 18.7594 14.7581Z",
    fill: "#AF0100"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3827 17.5508C16.8123 18.8286 17.5638 19.4674 18.6373 19.4674C19.7035 19.4674 20.4575 18.8371 20.8991 17.5764L16.3827 17.5508Z",
    fill: "#5EAA22"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9763 14.4043L16.5751 13.07C17.3114 12.6764 18.0213 12.4771 18.7034 12.4771C19.3855 12.4771 20.0955 12.6764 20.8318 13.07L20.4306 14.4043C19.8166 14.0761 19.2414 13.9146 18.7034 13.9146C18.1655 13.9146 17.5902 14.0761 16.9763 14.4043Z",
    fill: "#82B2CB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9688 15.3332C18.3657 15.3332 18.6875 14.9041 18.6875 14.3748C18.6875 13.8456 18.3657 13.4165 17.9688 13.4165C17.5718 13.4165 17.25 13.8456 17.25 14.3748C17.25 14.9041 17.5718 15.3332 17.9688 15.3332Z",
    fill: "#FECA00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3999 16.8664C18.7969 16.8664 19.1187 16.4373 19.1187 15.908C19.1187 15.3788 18.7969 14.9497 18.3999 14.9497C18.0029 14.9497 17.6812 15.3788 17.6812 15.908C17.6812 16.4373 18.0029 16.8664 18.3999 16.8664Z",
    fill: "#8A4E22"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 16.0998C17.647 16.0998 17.9688 15.6707 17.9688 15.1414C17.9688 14.6122 17.647 14.1831 17.25 14.1831C16.853 14.1831 16.5312 14.6122 16.5312 15.1414C16.5312 15.6707 16.853 16.0998 17.25 16.0998Z",
    fill: "#AF0100"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6937 16.0998C20.0907 16.0998 20.4125 15.6707 20.4125 15.1414C20.4125 14.6122 20.0907 14.1831 19.6937 14.1831C19.2968 14.1831 18.975 14.6122 18.975 15.1414C18.975 15.6707 19.2968 16.0998 19.6937 16.0998Z",
    fill: "#AF0100"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1906 18.2082C19.4685 18.2082 19.6938 17.7791 19.6938 17.2498C19.6938 16.7206 19.4685 16.2915 19.1906 16.2915C18.9128 16.2915 18.6875 16.7206 18.6875 17.2498C18.6875 17.7791 18.9128 18.2082 19.1906 18.2082Z",
    fill: "#AF0100"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4655 18.2082C17.7434 18.2082 17.9687 17.7791 17.9687 17.2498C17.9687 16.7206 17.7434 16.2915 17.4655 16.2915C17.1877 16.2915 16.9624 16.7206 16.9624 17.2498C16.9624 17.7791 17.1877 18.2082 17.4655 18.2082Z",
    fill: "#AF0100"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12.9375,
    height: 13.4167,
    fill: "#2E42A5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2402_3504",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 14
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 12.9375,
    height: 13.4167,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2402_3504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.44055 12.4582L1.40638 14.123L13.0021 1.81011L14.5038 -0.663855L11.4594 -1.22029L6.7298 4.08571L2.92294 7.66071L-1.44055 12.4582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.05078 13.6247L0.3996 14.5908L13.9646 -0.893656H11.9281L-1.05078 13.6247Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3781 12.4582L11.5311 14.123L-0.0646162 1.81011L-1.56631 -0.663855L1.47808 -1.22029L6.2077 4.08571L10.0146 7.66071L14.3781 12.4582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2809 13.2956L12.8305 14.2617L7.05439 7.63201L5.3419 6.89129L-1.71083 -0.655139H0.325672L7.37444 6.71217L9.24675 7.60037L14.2809 13.2956Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.24998 -0.5V-1H4.74998V-0.5H5.24998ZM5.24998 4.35371V4.85371H5.74998V4.35371H5.24998ZM-0.488892 4.35371V3.85371H-0.988892V4.35371H-0.488892ZM-0.488892 9.18705H-0.988892V9.68705H-0.488892V9.18705ZM5.24998 9.18705H5.74998V8.68705H5.24998V9.18705ZM5.24998 13.9167H4.74998V14.4167H5.24998V13.9167ZM7.68748 13.9167V14.4167H8.18748V13.9167H7.68748ZM7.68748 9.18705V8.68705H7.18748V9.18705H7.68748ZM13.4486 9.18705V9.68705H13.9486V9.18705H13.4486ZM13.4486 4.35371H13.9486V3.85371H13.4486V4.35371ZM7.68748 4.35371H7.18748V4.85371H7.68748V4.35371ZM7.68748 -0.5H8.18748V-1H7.68748V-0.5ZM6.68748 4.35371V4.85371H7.18748V4.35371H6.68748ZM6.68748 0.5H7.18748V0H6.68748V0.5ZM6.24998 0.5V0H5.74998V0.5H6.24998ZM6.24998 4.35371H5.74998V4.85371H6.24998V4.35371ZM6.68748 5.35371H7.18748V4.85371H6.68748V5.35371ZM6.24998 5.35371V4.85371H5.74998V5.35371H6.24998ZM6.68748 8.18705V8.68705H7.18748V8.18705H6.68748ZM6.24998 8.18705H5.74998V8.68705H6.24998V8.18705ZM5.24998 5.35371H5.74998V4.85371H5.24998V5.35371ZM0.511108 5.35371V4.85371H0.0111084V5.35371H0.511108ZM0.511108 8.18705H0.0111084V8.68705H0.511108V8.18705ZM5.24998 8.18705V8.68705H5.74998V8.18705H5.24998ZM6.24998 9.18705V8.68705H5.74998V9.18705H6.24998ZM6.24998 12.9167H5.74998V13.4167H6.24998V12.9167ZM6.68748 12.9167V13.4167H7.18748V12.9167H6.68748ZM6.68748 9.18705H7.18748V8.68705H6.68748V9.18705ZM7.68748 5.35371V4.85371H7.18748V5.35371H7.68748ZM7.68748 8.18705H7.18748V8.68705H7.68748V8.18705ZM12.4486 5.35371H12.9486V4.85371H12.4486V5.35371ZM12.4486 8.18705V8.68705H12.9486V8.18705H12.4486ZM5.24998 0H5.74998V-1H5.24998V0ZM5.74998 0V-0.5H4.74998V0H5.74998ZM5.74998 4.35371V0H4.74998V4.35371H5.74998ZM0.0111084 4.85371H5.24998V3.85371H0.0111084V4.85371ZM-0.488892 4.85371H0.0111084V3.85371H-0.488892V4.85371ZM0.0111084 4.85371V4.35371H-0.988892V4.85371H0.0111084ZM0.0111084 8.68705V4.85371H-0.988892V8.68705H0.0111084ZM0.0111084 9.18705V8.68705H-0.988892V9.18705H0.0111084ZM0.0111084 8.68705H-0.488892V9.68705H0.0111084V8.68705ZM5.24998 8.68705H0.0111084V9.68705H5.24998V8.68705ZM5.74998 13.4167V9.18705H4.74998V13.4167H5.74998ZM5.74998 13.9167V13.4167H4.74998V13.9167H5.74998ZM5.74998 13.4167H5.24998V14.4167H5.74998V13.4167ZM7.18748 13.4167H5.74998V14.4167H7.18748V13.4167ZM7.68748 13.4167H7.18748V14.4167H7.68748V13.4167ZM7.18748 13.4167V13.9167H8.18748V13.4167H7.18748ZM7.18748 9.18705V13.4167H8.18748V9.18705H7.18748ZM12.9486 8.68705H7.68748V9.68705H12.9486V8.68705ZM13.4486 8.68705H12.9486V9.68705H13.4486V8.68705ZM12.9486 8.68705V9.18705H13.9486V8.68705H12.9486ZM12.9486 4.85371V8.68705H13.9486V4.85371H12.9486ZM12.9486 4.35371V4.85371H13.9486V4.35371H12.9486ZM12.9486 4.85371H13.4486V3.85371H12.9486V4.85371ZM7.68748 4.85371H12.9486V3.85371H7.68748V4.85371ZM7.18748 0V4.35371H8.18748V0H7.18748ZM7.18748 -0.5V0H8.18748V-0.5H7.18748ZM7.18748 0H7.68748V-1H7.18748V0ZM5.74998 0H7.18748V-1H5.74998V0ZM7.18748 4.35371V0.5H6.18748V4.35371H7.18748ZM6.68748 0H6.24998V1H6.68748V0ZM5.74998 0.5V4.35371H6.74998V0.5H5.74998ZM6.24998 4.85371H6.68748V3.85371H6.24998V4.85371ZM6.68748 4.85371H6.24998V5.85371H6.68748V4.85371ZM7.18748 8.18705V5.35371H6.18748V8.18705H7.18748ZM6.24998 8.68705H6.68748V7.68705H6.24998V8.68705ZM5.74998 5.35371V8.18705H6.74998V5.35371H5.74998ZM5.24998 4.85371H0.511108V5.85371H5.24998V4.85371ZM0.0111084 5.35371V8.18705H1.01111V5.35371H0.0111084ZM0.511108 8.68705H5.24998V7.68705H0.511108V8.68705ZM5.74998 8.18705V5.35371H4.74998V8.18705H5.74998ZM5.74998 9.18705V12.9167H6.74998V9.18705H5.74998ZM6.24998 13.4167H6.68748V12.4167H6.24998V13.4167ZM7.18748 12.9167V9.18705H6.18748V12.9167H7.18748ZM6.68748 8.68705H6.24998V9.68705H6.68748V8.68705ZM7.18748 5.35371V8.18705H8.18748V5.35371H7.18748ZM12.4486 4.85371H7.68748V5.85371H12.4486V4.85371ZM12.9486 8.18705V5.35371H11.9486V8.18705H12.9486ZM7.68748 8.68705H12.4486V7.68705H7.68748V8.68705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.18748 0H5.74998V4.85371H0.0111084V8.68705H5.74998V13.4167H7.18748V8.68705H12.9486V4.85371H7.18748V0Z",
    fill: "#F50100"
  }))))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2402_3504)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2402_3504",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBmd);
export default __webpack_public_path__ + "static/media/BMD.7c721ee06a16fac5f64310a74adcb6b4.svg";
export { ForwardRef as ReactComponent };